import React, { useRef, useState, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Templete from "../../Templete/Templete";

import AuthService from "../../../../services/Admin/AuthService";
import UtiPanCardService from "../../../../services/Admin/UtiPanCardService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";
import { states } from "../../../../utill/Common";

import DistrictListFunction from "../../../User/Services/UTI_v2/DistrictList";

const UtiV2EditCrPanForm = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [data, setData] = useState();
  const [panData, setPanData] = useState({});

  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    loadingCtx.startLoading();

    const id = props.id ? props.id : props.match.params.id;

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UtiPanCardService.v2FetchById(token, id);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setData(responseData.data);

        var _panData = JSON.parse(responseData.data.secret_log1);
        //   alert(JSON.stringify(_panData?.request?.data));
        setPanData(_panData?.request?.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const getFormattedDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0"); // Add leading zero
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = today.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPanData((prevData) => ({
      ...prevData,
      [name]: value, // Update the property dynamically based on the input's name
    }));
  };

  const [districtList, setDistrictList] = useState();

  const handleGetDistrictList = (e) => {
    const { name, value } = e.target;

    const districts = DistrictListFunction.list;

    // Update the districts for the selected state
    if (districts[value]) {
      setDistrictList(districts[value]);
    } else {
      setDistrictList([]);
    }
  };

  const formRef = useRef();

  const validateEmail = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  };

  const validateMobile = (input) => {
    const mobileRegex = /^[6-9]\d{9}$/; // Starts with 6-9 and is 10 digits long
    return mobileRegex.test(input);
  };

  const submitHandler = async () => {
    const date = getFormattedDate();

    // setPanData((prevData) => ({
    //   ...prevData,
    //   ["date"]: date, // Update the property dynamically based on the input's name
    // }));

    if (panData.csfTitle == "") {
      Swal.fire("Opps!", "Please Select Title", "error");
      return;
    }

    if (panData.csfSurname == "") {
      Swal.fire("Opps!", "Please Enter Last Name", "error");
      return;
    }

    if (panData.csfCardName == "") {
      Swal.fire("Opps!", "Please Enter Name On Card", "error");
      return;
    }

    if (panData.csfGender == "") {
      Swal.fire("Opps!", "Please Select Gender", "error");
      return;
    }

    if (panData.csfDob == "") {
      Swal.fire("Opps!", "Please Enter Date of Birth", "error");
      return;
    }

    if (
      panData.csfUidNo == "" ||
      panData.csfUidNo.length < 12 ||
      panData.csfUidNo.length > 12
    ) {
      Swal.fire("Opps!", "Please Enter Valid Aadhaar Number", "error");
      return;
    }

    if (!validateMobile(panData.csfTelNo)) {
      Swal.fire("Opps!", "Please Enter Valid Mobile Number", "error");
      return;
    }

    if (!validateEmail(panData.csfEmail)) {
      Swal.fire("Opps!", "Please Enter Email Address", "error");
      return;
    }

    if (panData.csfFthSurname == "") {
      Swal.fire("Opps!", "Please Enter Father's Last Name", "error");
      return;
    }

    if (
      panData.csfCommAddr1 == "" ||
      panData.csfCommAddr2 == "" ||
      panData.csfCommAddr3 == "" ||
      panData.csfCommAddr4 == "" ||
      panData.csfCommDist == ""
    ) {
      Swal.fire("Opps!", "Please Enter Complete Address", "error");
      return;
    }

    if (
      panData.csfCommPin == "" ||
      panData.csfCommPin.length < 6 ||
      panData.csfCommPin.length > 6
    ) {
      Swal.fire("Opps!", "Please Enter Valid PIN Code", "error");
      return;
    }

    if (panData.csfCommState == "") {
      Swal.fire("Opps!", "Please Select State", "error");
      return;
    }

    // FOR MINOR CASA
    if (panData.minorCase == "Y") {
      //
      //   if (panData.repTitle == "") {
      //     Swal.fire("Opps!", "Please Select RA Title", "error");
      //     return;
      //   }
      //   if (panData.repLast == "") {
      //     Swal.fire("Opps!", "Please Enter RA Last name", "error");
      //     return;
      //   }
      //   if (
      //     panData.repAddr1 == "" ||
      //     panData.repAddr2 == "" ||
      //     panData.repAddr3 == "" ||
      //     panData.repAddr4 == "" ||
      //     panData.repDist == ""
      //   ) {
      //     Swal.fire("Opps!", "Please Enter RA Complete Address", "error");
      //     return;
      //   }
      //   if (
      //     panData.repPin == "" ||
      //     panData.repPin.length < 6 ||
      //     panData.repPin.length > 6
      //   ) {
      //     Swal.fire("Opps!", "Please Enter RA Valid PIN Code", "error");
      //     return;
      //   }
      //   if (panData.repState == "") {
      //     Swal.fire("Opps!", "Please Select RA State", "error");
      //     return;
      //   }
      //
    }

    loadingCtx.startLoading();

    // const district = panData.resDist;

    // const nameOnCard =
    //   panData.firstName + " " + panData.middleName + " " + panData.lastName;

    // const _panData = {
    //   ...panData,
    //   verName: nameOnCard,
    //   verPlace: district,
    // };

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UtiPanCardService.v2UpdatePANForm(
        token,
        data?.order_id || "",
        panData
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        // formRef.current.reset();
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const getName = (e) => {
    let fName = panData.csfFirstName;
    let mName = panData.csfMidName;
    let lName = panData.csfSurname;

    const { name, value } = e.target;

    if (name == "csfFirstName") {
      fName = value;
    }

    if (name == "csfMidName") {
      mName = value;
    }

    if (name == "csfSurname") {
      lName = value;
    }

    let fullname = fName + " " + mName + " " + lName;

    setPanData((prevData) => ({
      ...prevData,
      csfCardName: fullname.trim(),
      csfUidName: fullname.trim(),
    }));
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Edit PAN Form">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title">Edit PAN Form - CR</h3>
                  </div>

                  {/* {JSON.stringify(panData)} */}

                  <div class="row">
                    <div class="col-md-12 mx-auto">
                      <form ref={formRef} autoComplete="off">
                        <div class="card-body">
                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label for="exampleInputEmail1">
                                  CSF PAN NO <span className="red">*</span>
                                </label>
                                <input
                                  class="form-control uppercase"
                                  placeholder="CSF PAN NO"
                                  name="csfPanNo"
                                  value={panData.csfPanNo}
                                  onChange={(e) => {
                                    handleInputChange(e);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label for="exampleInputEmail1">
                                  Title <span className="red">*</span>
                                </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfTitle"
                                  value={panData.csfTitle}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Title</option>
                                  <option value="1">SHRI</option>
                                  <option value="2">SMT</option>
                                  <option value="3">KUMARI</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Last Name/Surname{" "}
                                  <span className="red">*</span>{" "}
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Last Name/Surname"
                                  name="csfSurname"
                                  value={panData.csfSurname}
                                  onChange={(e) => {
                                    handleInputChange(e);
                                    getName(e);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>First Name</label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="First name"
                                  name="csfFirstName"
                                  value={panData.csfFirstName}
                                  onChange={(e) => {
                                    handleInputChange(e);
                                    //  getName(e);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Middle Name</label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Middle name"
                                  name="csfMidName"
                                  value={panData.csfMidName}
                                  onChange={(e) => {
                                    handleInputChange(e);
                                    //  getName(e);
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Name on Card <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Name on Card"
                                  name="csfCardName"
                                  value={panData.csfCardName}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Gender <span className="red">*</span>
                                </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfGender"
                                  value={panData.csfGender}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Gender</option>
                                  <option value="M">MALE</option>
                                  <option value="F">FEMALE</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Date of Birth <span className="red">*</span>
                                </label>
                                <input
                                  type="date"
                                  class="form-control uppercase"
                                  name="csfDob"
                                  value={panData.csfDob}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Aadhaar Number <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Aadhaar Number"
                                  name="csfUidNo"
                                  value={panData.csfUidNo}
                                  onChange={handleInputChange}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  maxLength={12}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Name as per Aadhaar{" "}
                                  <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Name as per Aadhaar"
                                  name="csfUidName"
                                  value={panData.csfUidName}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Mobile Number <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Mobile Number"
                                  name="csfTelNo"
                                  value={panData.csfTelNo}
                                  onChange={handleInputChange}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  maxLength={10}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Email Address <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Email Address"
                                  name="csfEmail"
                                  value={panData.csfEmail}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="pt-2 pb-3">
                            <hr />
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Father's Last Name{" "}
                                  <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Father's Last Name"
                                  name="csfFthSurname"
                                  value={panData.csfFthSurname}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Father's First Name</label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Father's First Name"
                                  name="csfFthFirstName"
                                  value={panData.csfFthFirstName}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Father's Middle Name</label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Father's Middle Name"
                                  name="csfFthMidName"
                                  value={panData.csfFthMidName}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="pt-2 pb-3">
                            <hr />
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Flat/Room/Door/Block No{" "}
                                  <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Flat/Room/Door/Block No"
                                  name="csfCommAddr1"
                                  value={panData.csfCommAddr1}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Building/Village Name</label>{" "}
                                <span className="red">*</span>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Building/Village Name"
                                  name="csfCommAddr2"
                                  value={panData.csfCommAddr2}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Road/Street/Lane/Post Office</label>{" "}
                                <span className="red">*</span>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Road/Street/Lane/Post Office"
                                  name="csfCommAddr3"
                                  value={panData.csfCommAddr3}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Area/Locality/Sub-Division</label>{" "}
                                <span className="red">*</span>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Area/Locality/Sub-Division"
                                  name="csfCommAddr4"
                                  value={panData.csfCommAddr4}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  State/Union Territory{" "}
                                  <span className="red">*</span>
                                </label>

                                <select
                                  className="form-control uppercase"
                                  name="csfCommState"
                                  value={panData.csfCommState}
                                  onChange={(e) => {
                                    handleInputChange(e);
                                    handleGetDistrictList(e);

                                    const selectedLabel =
                                      e.target.selectedOptions[0].text;

                                    if (selectedLabel) {
                                      let data = {
                                        target: {
                                          name: "state",
                                          value: selectedLabel,
                                        },
                                      };

                                      handleInputChange(data);
                                    }
                                  }}
                                >
                                  <option value="">Please Select</option>
                                  <option value="1">
                                    ANDAMAN AND NICOBAR ISLANDS
                                  </option>
                                  <option value="2">ANDHRA PRADESH</option>
                                  <option value="3">ARUNACHAL PRADESH</option>
                                  <option value="4">ASSAM</option>
                                  <option value="5">BIHAR</option>
                                  <option value="6">CHANDIGARH</option>
                                  <option value="33">CHHATTISGARH</option>
                                  <option value="7">
                                    DADRA AND NAGAR HAVELI
                                  </option>
                                  <option value="8">DAMAN AND DIU</option>
                                  <option value="9">DELHI</option>
                                  <option value="10">GOA</option>
                                  <option value="11">GUJARAT</option>
                                  <option value="12">HARYANA</option>
                                  <option value="13">HIMACHAL PRADESH</option>
                                  <option value="14">JAMMU AND KASHMIR</option>
                                  <option value="35">JHARKHAND</option>
                                  <option value="15">KARNATAKA</option>
                                  <option value="16">KERALA</option>
                                  <option value="37">LADAKH</option>
                                  <option value="17">LAKSHADWEEP</option>
                                  <option value="18">MADHYA PRADESH</option>
                                  <option value="19">MAHARASHTRA</option>
                                  <option value="20">MANIPUR</option>
                                  <option value="21">MEGHALAYA</option>
                                  <option value="22">MIZORAM</option>
                                  <option value="23">NAGALAND</option>
                                  <option value="24">ODISHA</option>
                                  <option value="99">OTHER</option>
                                  <option value="25">PONDICHERRY</option>
                                  <option value="26">PUNJAB</option>
                                  <option value="27">RAJASTHAN</option>
                                  <option value="28">SIKKIM</option>
                                  <option value="29">TAMIL NADU</option>
                                  <option value="36">TELANGANA</option>
                                  <option value="30">TRIPURA</option>
                                  <option value="31">UTTAR PRADESH</option>
                                  <option value="34">UTTARAKHAND</option>
                                  <option value="32">WEST BENGAL</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Town/City/District</label>{" "}
                                <span className="red">*</span>
                                <select
                                  className="form-control uppercase"
                                  name="csfCommDist"
                                  value={panData.csfCommDist}
                                  onChange={handleInputChange}
                                >
                                  {districtList &&
                                    districtList.map((district, index) => (
                                      <option key={index} value={district}>
                                        {district}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>PIN Code</label>{" "}
                                <span className="red">*</span>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="PIN Code"
                                  name="csfCommPin"
                                  value={panData.csfCommPin}
                                  onChange={handleInputChange}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  maxLength={6}
                                />
                              </div>
                            </div>
                          </div>

                          {/*    <div className="pt-2 pb-3">
                            <hr />
                            <h5>
                              <b>Representative Assessee (RA)</b>
                            </h5>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Minor Case <span className="red">*</span>
                                </label>
                                <select
                                  className="form-control uppercase"
                                  name="minorCase"
                                  value={panData.minorCase}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select</option>
                                  <option value="Y">YES</option>
                                  <option value="N" selected>
                                    NO
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>   */}
                          {/* 
                          {panData.minorCase == "Y" && (
                            <div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label for="exampleInputEmail1">
                                      Title <span className="red">*</span>
                                    </label>
                                    <select
                                      className="form-control uppercase"
                                      name="repTitle"
                                      value={panData.repTitle}
                                      onChange={handleInputChange}
                                    >
                                      <option value="">Select Title</option>
                                      <option value="1">SHRI</option>
                                      <option value="2">SMT</option>
                                      <option value="3">KUMARI</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>
                                      Last Name/Surname{" "}
                                      <span className="red">*</span>{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="Last Name/Surname"
                                      name="repLast"
                                      value={panData.repLast}
                                      onChange={(e) => {
                                        handleInputChange(e);
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>First Name</label>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="First name"
                                      name="repFirst"
                                      value={panData.repFirst}
                                      onChange={(e) => {
                                        handleInputChange(e);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>Middle Name</label>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="Middle name"
                                      name="repMiddle"
                                      value={panData.repMiddle}
                                      onChange={(e) => {
                                        handleInputChange(e);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>
                                      Flat/Room/Door/Block No{" "}
                                      <span className="red">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="Flat/Room/Door/Block No"
                                      name="repAddr1"
                                      value={panData.repAddr1}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>Building/Village Name</label>{" "}
                                    <span className="red">*</span>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="Building/Village Name"
                                      name="repAddr2"
                                      value={panData.repAddr2}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>Road/Street/Lane/Post Office</label>{" "}
                                    <span className="red">*</span>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="Road/Street/Lane/Post Office"
                                      name="repAddr3"
                                      value={panData.repAddr3}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>Area/Locality/Sub-Division</label>{" "}
                                    <span className="red">*</span>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="Area/Locality/Sub-Division"
                                      name="repAddr4"
                                      value={panData.repAddr4}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>
                                      State/Union Territory{" "}
                                      <span className="red">*</span>
                                    </label>

                                    <select
                                      className="form-control uppercase"
                                      name="repState"
                                      value={panData.repState}
                                      onChange={(e) => {
                                        handleInputChange(e);
                                        handleGetDistrictList(e);
                                      }}
                                    >
                                      <option value="">Please Select</option>
                                      <option value="1">
                                        ANDAMAN AND NICOBAR ISLANDS
                                      </option>
                                      <option value="2">ANDHRA PRADESH</option>
                                      <option value="3">
                                        ARUNACHAL PRADESH
                                      </option>
                                      <option value="4">ASSAM</option>
                                      <option value="5">BIHAR</option>
                                      <option value="6">CHANDIGARH</option>
                                      <option value="33">CHHATTISGARH</option>
                                      <option value="7">
                                        DADRA AND NAGAR HAVELI
                                      </option>
                                      <option value="8">DAMAN AND DIU</option>
                                      <option value="9">DELHI</option>
                                      <option value="10">GOA</option>
                                      <option value="11">GUJARAT</option>
                                      <option value="12">HARYANA</option>
                                      <option value="13">
                                        HIMACHAL PRADESH
                                      </option>
                                      <option value="14">
                                        JAMMU AND KASHMIR
                                      </option>
                                      <option value="35">JHARKHAND</option>
                                      <option value="15">KARNATAKA</option>
                                      <option value="16">KERALA</option>
                                      <option value="37">LADAKH</option>
                                      <option value="17">LAKSHADWEEP</option>
                                      <option value="18">MADHYA PRADESH</option>
                                      <option value="19">MAHARASHTRA</option>
                                      <option value="20">MANIPUR</option>
                                      <option value="21">MEGHALAYA</option>
                                      <option value="22">MIZORAM</option>
                                      <option value="23">NAGALAND</option>
                                      <option value="24">ODISHA</option>
                                      <option value="99">OTHER</option>
                                      <option value="25">PONDICHERRY</option>
                                      <option value="26">PUNJAB</option>
                                      <option value="27">RAJASTHAN</option>
                                      <option value="28">SIKKIM</option>
                                      <option value="29">TAMIL NADU</option>
                                      <option value="36">TELANGANA</option>
                                      <option value="30">TRIPURA</option>
                                      <option value="31">UTTAR PRADESH</option>
                                      <option value="34">UTTARAKHAND</option>
                                      <option value="32">WEST BENGAL</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>Town/City/District</label>{" "}
                                    <span className="red">*</span>
                                    <select
                                      className="form-control uppercase"
                                      name="repDist"
                                      value={panData.repDist}
                                      onChange={handleInputChange}
                                    >
                                      {districtList &&
                                        districtList.map((district, index) => (
                                          <option key={index} value={district}>
                                            {district}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div class="form-group">
                                    <label>PIN Code</label>{" "}
                                    <span className="red">*</span>
                                    <input
                                      type="text"
                                      class="form-control uppercase"
                                      placeholder="PIN Code"
                                      name="repPin"
                                      value={panData.repPin}
                                      onChange={handleInputChange}
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      maxLength={6}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )} */}

                          <div className="pt-2 pb-3">
                            <hr />
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Name Change</label>
                                <select
                                  className="form-control uppercase"
                                  name="csfNmChangeFlag"
                                  value={panData.csfNmChangeFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Name Change</option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Name Correction</label>
                                <select
                                  className="form-control uppercase"
                                  name="csfNmCorrFlag"
                                  value={panData.csfNmCorrFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select Name Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Father's Correction </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfFthNmCorrFlag"
                                  value={panData.csfFthNmCorrFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select Father's Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Gender Correction </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfGenderCorrFlag"
                                  value={panData.csfGenderCorrFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select Gender Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>DOB Correction</label>
                                <select
                                  className="form-control uppercase"
                                  name="csfDobCorrFlag"
                                  value={panData.csfDobCorrFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select DOB Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Address Correction </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfResCorrFlag"
                                  value={panData.csfResCorrFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select Address Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Photo Correction </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfPhotoFlag"
                                  value={panData.csfPhotoFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select Photo Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Sign Correction </label>
                                <select
                                  className="form-control uppercase"
                                  name="csfSignFlag"
                                  value={panData.csfSignFlag}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    Select Sign Correction
                                  </option>
                                  <option value="Y">YES</option>
                                  <option value="N">NO</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Proof of Identity</label>{" "}
                                <span className="red">*</span>
                                <select className="form-control uppercase">
                                  <option selected>AADHAAR CARD</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Proof of Address
                                  <span className="red">*</span>
                                </label>
                                <select className="form-control uppercase">
                                  <option selected>AADHAAR CARD</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>Proof of Birth</label>{" "}
                                <span className="red">*</span>
                                <select className="form-control uppercase">
                                  <option selected>AADHAAR CARD</option>
                                </select>
                              </div>
                            </div>
                          </div> */}

                          <div className="pt-2 pb-3">
                            <hr />
                          </div>

                          {/* <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>VLE Name</label>{" "}
                                <span className="red">*</span>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Agent Name"
                                  name="verName"
                                  value={panData.verName}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  VLE Place
                                  <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="VLE Place"
                                  name="verPlace"
                                  value={panData.verPlace}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div> */}

                          <div className="pt-2 pb-3">
                            <hr />
                          </div>

                          <div className="row">
                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>
                                  Number fo Documents
                                  <span className="red">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Number fo Documents (Example: 2)"
                                  name="csfDocNumber"
                                  value={panData.csfDocNumber}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div class="form-group">
                                <label>PAN Type</label>{" "}
                                <span className="red">*</span>
                                <select className="form-control uppercase">
                                  <option selected>Normal</option>
                                </select>
                              </div>
                            </div>
                            {/* <div className="col-sm-4">
                              <div class="form-group">
                                <label>Charges</label>{" "}
                                <span className="red">*</span>
                                <input
                                  type="text"
                                  class="form-control uppercase"
                                  placeholder="Processing Fee: ₹120"
                                  readOnly
                                />
                              </div>
                            </div> */}
                          </div>

                          <div className="pt-2 pb-3">
                            <hr />
                          </div>

                          {/* <div style={alertStyle}>
                            <strong style={strongStyle}>Important Note:</strong>
                            <ul>
                              <li>
                                Once the form is submitted,{" "}
                                <strong>no refunds will be processed</strong>.
                              </li>
                              <li>
                                Ensure you upload all documents{" "}
                                <strong>correctly</strong> and{" "}
                                <strong>accurately</strong>.
                              </li>
                              <li>
                                We are <strong>not responsible</strong> for any
                                issues arising from the{" "}
                                <strong>entry of incorrect details</strong>.
                              </li>
                            </ul>
                            <p>
                              Please verify all information before submission.
                            </p>
                          </div> */}

                          {/* {JSON.stringify(panData)} */}

                          <div class="text-center pb-3">
                            <button
                              type="button"
                              class="btn btn-primary"
                              onClick={submitHandler}
                            >
                              Update PAN Form
                            </button>
                            <button type="reset" class="btn btn-default ml-5">
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default UtiV2EditCrPanForm;
